// F-081-T8 — league_config → LeagueTab form coercion.
//
// The League tab binds season dates to <input type="date"> (needs
// 'YYYY-MM-DD') and the tee time to <input type="time"> (default step=60,
// so it needs 'HH:MM' and REJECTS a seconds-bearing 'HH:MM:SS', rendering
// blank). A league_configs row can reach the form in several serialized
// shapes depending on the read path:
//   - dates already cast ::text  → 'YYYY-MM-DD'
//   - a raw postgres.js Date object (if a read path forgot the cast)
//   - a full ISO datetime string  → '2026-08-15T00:00:00.000Z'
//   - a `time` column             → 'HH:MM:SS' or 'HH:MM:SS.ffffff'
// These pure coercers make the form render the SAVED value back instead of
// blanking it, which is the "editing settings never saves" bug the owner
// reported (the row WAS written; it just failed to hydrate on reopen).
//
// db.js get_event_admin_view is the primary normalization boundary
// (default_start_time is emitted as 'HH:MM' there); this is the
// belt-and-suspenders layer so a stale or alternate payload still hydrates.

/** Coerce any date-ish value into an <input type="date"> value ('YYYY-MM-DD') or ''. */
export function toDateInputValue(v) {
  if (v == null || v === '') return ''
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? '' : v.toISOString().slice(0, 10)
  const s = String(v)
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/) // 'YYYY-MM-DD' head of a date or ISO datetime
  return m ? m[1] : ''
}

/** Coerce any time-ish value into an <input type="time"> value ('HH:MM') or ''. */
export function toTimeInputValue(v) {
  if (v == null || v === '') return ''
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? '' : v.toISOString().slice(11, 16)
  const s = String(v)
  const iso = s.match(/T(\d{2}:\d{2})/) // ISO datetime → the HH:MM after the 'T'
  if (iso) return iso[1]
  const m = s.match(/^(\d{2}:\d{2})/) // 'HH:MM' / 'HH:MM:SS' / 'HH:MM:SS.ffffff'
  return m ? m[1] : ''
}

/**
 * Normalize the date/time members of a league_config row into HTML-input
 * shape, leaving every other field untouched. Returns null for a null row.
 * Only rewrites keys that are present so partial payloads pass through.
 */
export function normalizeLeagueConfigForForm(cfg) {
  if (!cfg) return null
  const out = { ...cfg }
  if ('season_start_date' in cfg) out.season_start_date = toDateInputValue(cfg.season_start_date)
  if ('season_end_date' in cfg) out.season_end_date = toDateInputValue(cfg.season_end_date)
  if ('default_start_time' in cfg) out.default_start_time = toTimeInputValue(cfg.default_start_time)
  return out
}
